
import { defineComponent } from 'vue';
import {
  Matomo,
  translate,
} from 'CoreHome';

export default defineComponent({
  props: {
    websites: {
      type: Array,
      required: true,
    },
    linkLabel: {
      type: String,
      required: true,
    },
    modalTitle: String,
  },
  methods: {
    openModal() {
      Matomo.helper.modalConfirm(
        this.$refs.websitesAvailableModal as HTMLElement,
        {},
        {
          classes: 'websites-available-modal-dialog',
        } as unknown as Parameters<typeof Matomo.helper.modalConfirm>[2],
      );
    },
  },
  computed: {
    actualModalTitle(): string {
      return this.modalTitle
        || translate('SearchEngineKeywordsPerformance_AvailableWebsitesForImport');
    },
    sortedWebsites(): string[] {
      return [...this.websites as string[]].sort((first, second) => (
        first.localeCompare(second, undefined, { sensitivity: 'base' })
      ));
    },
  },
});
